import { fetchGetJSONReqOpts, fetchGetJSONResHandler } from '../modules/ajio-fetch/utils';
import fetcher from '../modules/ajio-fetch';

const plpTopBannerApi = () => {
  const apiEndPoint = '/api/plp/topBanner';
  // returningUserImageUrl
  // newUserImageUrl
  return fetcher(
    apiEndPoint,
    fetchGetJSONReqOpts({
      method: 'GET',
      headers: {
        Accept: 'application/json, text/plain, */*',
        'Content-Type': 'application/json'
      }
    })
  ).then(fetchGetJSONResHandler);
};

function getPlpTopBannerSuccess(data = {}) {
  return {
    type: 'GET_PLP_TOP_BANNER_SUCCESS',
    data
  };
}
function getPlpTopBannerError() {
  return {
    type: 'GET_PLP_TOP_BANNER_ERROR',
    data: {}
  };
}

// actions
function getPlpTopBanner() {
  return dispatch => {
    return plpTopBannerApi()
      .then(response => {
        dispatch(getPlpTopBannerSuccess(response));
        return Promise.resolve(response);
      })
      .catch(() => {
        dispatch(getPlpTopBannerError());
        return Promise.reject(new Error('event api error'));
      });
  };
}

export default getPlpTopBanner;
